import {asyncSleep} from "./utilities/general";

/**
 * Create a spinner that can be added and removed around a particular task.
 * @todo  Fix the debugWait feature.... currently not working
 * @param name            - A unique identifier for this spinner
 * @param targetSelector  - selector to target an element in the DOM that will serve as the anchor for the spinner
 * @param insertPosition  - where to insert the spinner in relation to the anchor element. Used with call to
 *                          Element.insertAdjacentElement() method
 * @param withWrapper
 * @param debugWait number
 * @constructor
 */
function Spinner(name,
                 targetSelector,
                 insertPosition = 'afterend',
                 withWrapper = false ,
                 debugWait = 0) {
  this.name = name;
  this.waitInMilliseconds = debugWait === 0 ? 0.05 * 1000 : debugWait * 1000; // add slight delay if 0
  this.options = {
    spinner: {
      targetSelector,
      insertPosition,
      withWrapper
    }
  }

  /**
   * Adds the spinner to the DOM.
   *
   * @returns {void}
   */
  this.add = function () {
    const {spinner: spinnerOptions} = this.options;
    const {targetSelector, insertPosition, withWrapper = false} = spinnerOptions;
    const spinnerElem = document.querySelector(`.spinner-wrapper [data-name="${name}"]`);

    if (!spinnerElem) {
      // show spinner
      const span = document.createElement('span');
      span.classList.add('loader');

      const spinner = document.createElement('div');
      if (name) {
        spinner.dataset.name = name;
      }

      spinner.classList.add('loading-on-top');
      spinner.appendChild(span);

      // if debugging sleep is on
      if(this.waitInMilliseconds > 50) {
        spinner.style.backgroundColor = 'darkred';
      }

      let spinnerElements;

      // in some cases, we may need to have the spinner in its own wrapper div
      if (withWrapper) {
        let wrapper = document.createElement('div');
        wrapper.classList.add('spinner-wrapper');
        wrapper.appendChild(spinner);

        spinnerElements = wrapper;
      } else {
        spinnerElements = spinner;
      }

      let target = document.querySelector(`${targetSelector}`);
      if (target) {
        target.insertAdjacentElement(insertPosition, spinnerElements);
      }
    }
  }

  /**
   * Removes the spinner from the DOM.
   * @returns {boolean} - Returns true if the item was successfully removed, false otherwise.
   */
  this.remove = async function() {
    await asyncSleep(this.waitInMilliseconds);

    // using 'querySelectorAll' to ensure no spinner is left with this name attribute. This covers cases where an
    // error may cause an extra spinner to be in the DOM.
    document.querySelectorAll(`div[data-name='${this.name}']`).forEach((elem) => {
      // special case - only spinner with static wrapper and non-spinner elements in it (requested by Carolyn)
      if(elem.closest('[data-sort-by-wrapper]')) {
        elem.remove();
      } else {
        // if the spinner has a wrapper, remove wrapper with the spinner (There are some elements with a spinner-wrapper class; these elements should not be removed)
        if (this.options.spinner.withWrapper && elem.parentElement.classList.contains('spinner-wrapper')) {
          elem = elem.parentElement;
        }

        elem.remove();
      }
    })
  }
}

export {Spinner};
